import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function Layout({ children }) {
  return (
    <div className="grain relative min-h-screen bg-[#050505] text-white">
      <Header />
      <main>{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
